export default __webpack_public_path__ + "static/media/neha.fa23e190.jpg";